import { getPricingPolicies } from "./pricingPolicyCache";
import usePOSConfigStore from "../stores/usePOSConfigStore";

export function resolvePricingPolicy(product) {
  const posConfig = usePOSConfigStore.getState().posConfig;
  if (posConfig?.enablePricingPolicy !== "Y") return null;

  const policies = getPricingPolicies();
  if (!policies || policies.length === 0) return null;

  const productId = product?.mProductId || product?.productId || "";
  const brandId = product?.productBrandId || product?.brandId || "";
  const categoryId = product?.mProductCategoryId || "";

  if (productId) {
    const match = policies.find((p) => p.dimensionCode === "PRD" && p.dimensionValue === productId);
    if (match) return match;
  }

  if (brandId) {
    const match = policies.find((p) => p.dimensionCode === "BRD" && p.dimensionValue === brandId);
    if (match) return match;
  }

  if (categoryId) {
    const match = policies.find((p) => p.dimensionCode === "CAT" && p.dimensionValue === categoryId);
    if (match) return match;
  }

  return null;
}

export function shouldUseBatchPrice(product) {
  const policy = resolvePricingPolicy(product);
  return policy?.priceSource === "BTH";
}
